import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, filter, map, startWith } from 'rxjs';

export interface Breadcrumb {
  label: string;
  path: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  breadcrumbList$: Observable<Breadcrumb[]>;

  destroySubject: Subject<boolean> = new Subject();

  constructor(private location: Location,
    private router: Router,
    private activateRoute: ActivatedRoute) {}

  ngOnInit(): void {

    this.breadcrumbList$ = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(this.router),
        map(() => this.createBreadcrumbs(this.activateRoute.root))
      );
  }

  navigateBack(): void {
    this.location.back();
  }

  private createBreadcrumbs(route: ActivatedRoute, path: string = '', breadcrumbs: Breadcrumb[] = []) {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        path += `/${routeURL}`;
      }

      const label = child.snapshot.data[this.ROUTE_DATA_BREADCRUMB];
      if (!!label) {
        breadcrumbs.push({label, path});
      }

      return this.createBreadcrumbs(child, path, breadcrumbs);
    }
  }
}
